// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";

function compSlug(comp) {
  return comp.from + (" to " + (comp.dateTo + (", " + comp.location)));
}

const nullPilotStatus_pilotStatus = [];

const nullPilotStatus = {
  pilotId: "",
  pilotName: "",
  pilotStatus: nullPilotStatus_pilotStatus
};

function mkPilot(xs) {
  if (xs.length !== 2) {
    return {
      pilotId: "",
      pilotName: "",
      pilotStatus: []
    };
  }
  const match = xs[0];
  if (match.length !== 2) {
    return {
      pilotId: "",
      pilotName: "",
      pilotStatus: []
    };
  }
  const pilotId = match[0];
  const pilotName = match[1];
  const pilotStatus = xs[1];
  return {
    pilotId: pilotId,
    pilotName: pilotName,
    pilotStatus: pilotStatus
  };
}

function decodeError(expected, json) {
  return Stdlib.failwith("Expected " + (expected + (", got: " + JSON.stringify(json))));
}

function asString(json) {
  const s = Js__Js_json.classify(json);
  if (/* tag */ typeof s === "number" || typeof s === "string" || s.TAG !== /* JSONString */ 0) {
    return decodeError("string", json);
  } else {
    return s._0;
  }
}

function asFloat(json) {
  const n = Js__Js_json.classify(json);
  if (/* tag */ typeof n === "number" || typeof n === "string" || n.TAG !== /* JSONNumber */ 1) {
    return decodeError("number", json);
  } else {
    return n._0;
  }
}

function asBool(json) {
  const match = Js__Js_json.classify(json);
  if (!/* tag */ (typeof match === "number" || typeof match === "string")) {
    return decodeError("boolean", json);
  }
  switch (match) {
    case /* JSONFalse */ 0 :
      return false;
    case /* JSONTrue */ 1 :
      return true;
    default:
      return decodeError("boolean", json);
  }
}

function asDict(json) {
  const d = Js__Js_json.classify(json);
  if (/* tag */ typeof d === "number" || typeof d === "string" || d.TAG !== /* JSONObject */ 2) {
    return decodeError("object", json);
  } else {
    return d._0;
  }
}

function asArray(json) {
  const a = Js__Js_json.classify(json);
  if (/* tag */ typeof a === "number" || typeof a === "string" || a.TAG !== /* JSONArray */ 3) {
    return decodeError("array", json);
  } else {
    return a._0;
  }
}

function field(key, json) {
  const v = Js__Js_dict.get(asDict(json), key);
  if (v !== undefined) {
    return Caml_option.valFromOption(v);
  } else {
    return Stdlib.failwith("Missing field: " + key);
  }
}

function optField(key, decoder, json) {
  const v = Js__Js_dict.get(asDict(json), key);
  if (v === undefined) {
    return;
  }
  const v$1 = Caml_option.valFromOption(v);
  const match = Js__Js_json.classify(v$1);
  if (/* tag */ (typeof match === "number" || typeof match === "string") && match === /* JSONNull */ 2) {
    return;
  } else {
    return Caml_option.some(Curry._1(decoder, v$1));
  }
}

function decodeUtcOffset(json) {
  return {
    timeZoneMinutes: asFloat(field("timeZoneMinutes", json)) | 0
  };
}

function decodeRadius(json) {
  return {
    radius: asString(field("radius", json))
  };
}

function decodeGive(json) {
  return {
    giveDistance: optField("giveDistance", asString, json),
    giveFraction: asFloat(field("giveFraction", json))
  };
}

function decodeEarth(json) {
  return {
    sphere: decodeRadius(field("sphere", json))
  };
}

function decodeComp(json) {
  return {
    compName: asString(field("compName", json)),
    scoreBack: optField("scoreBack", asString, json),
    utcOffset: decodeUtcOffset(field("utcOffset", json)),
    from: asString(field("from", json)),
    dateTo: asString(field("to", json)),
    location: asString(field("location", json)),
    earth: decodeEarth(field("earth", json)),
    earthMath: asString(field("earthMath", json)),
    give: decodeGive(field("give", json))
  };
}

function decodeNominals(json) {
  return {
    free: asString(field("free", json)),
    distance: asString(field("distance", json)),
    time: asString(field("time", json)),
    goal: asFloat(field("goal", json))
  };
}

function decodeStopped(json) {
  return {
    announced: asString(field("announced", json)),
    retroactive: asString(field("retroactive", json))
  };
}

function decodeRawZone(json) {
  return {
    zoneName: asString(field("zoneName", json))
  };
}

function decodeRawZones(json) {
  return {
    raw: Stdlib__Array.map(decodeRawZone, asArray(field("raw", json)))
  };
}

function decodeTask(json) {
  return {
    taskName: asString(field("taskName", json)),
    zones: decodeRawZones(field("zones", json)),
    stopped: optField("stopped", decodeStopped, json),
    cancelled: optField("cancelled", asBool, json)
  };
}

function decodePilotStatuses(json) {
  return Stdlib__Array.map(mkPilot, Stdlib__Array.map((function (row) {
    return Stdlib__Array.map((function (el) {
      return Stdlib__Array.map(asString, asArray(el));
    }), asArray(row));
  }), asArray(json)));
}

function getComp(haveUrl, url, set) {
  if (!haveUrl) {
    return;
  }
  const dataUrl = url + "/comp-input/comps.json";
  fetch(dataUrl).then(function (prim) {
    return prim.json();
  }).then(function (json) {
    Curry._1(set, (function (param) {
      return decodeComp(json);
    }));
    return Promise.resolve();
  }).catch(function (param) {
    return Promise.resolve();
  });
}

function getNominals(haveUrl, url, set) {
  if (!haveUrl) {
    return;
  }
  const dataUrl = url + "/comp-input/nominals.json";
  fetch(dataUrl).then(function (prim) {
    return prim.json();
  }).then(function (json) {
    Curry._1(set, (function (param) {
      return decodeNominals(json);
    }));
    return Promise.resolve();
  }).catch(function (param) {
    return Promise.resolve();
  });
}

function getTaskLengths(haveUrl, url, set) {
  if (!haveUrl) {
    return;
  }
  const dataUrl = url + "/task-length/task-lengths.json";
  fetch(dataUrl).then(function (prim) {
    return prim.json();
  }).then(function (json) {
    Curry._1(set, (function (param) {
      return Stdlib__Array.map(asString, asArray(json));
    }));
    return Promise.resolve();
  }).catch(function (param) {
    return Promise.resolve();
  });
}

function getCompTasks(haveUrl, url, set) {
  if (!haveUrl) {
    return;
  }
  const dataUrl = url + "/comp-input/tasks.json";
  fetch(dataUrl).then(function (prim) {
    return prim.json();
  }).then(function (json) {
    Curry._1(set, (function (param) {
      return Stdlib__Array.map(decodeTask, asArray(json));
    }));
    return Promise.resolve();
  }).catch(function (param) {
    return Promise.resolve();
  });
}

function getCompPilots(haveUrl, url, set) {
  if (!haveUrl) {
    return;
  }
  const dataUrl = url + "/gap-point/pilots-status.json";
  fetch(dataUrl).then(function (prim) {
    return prim.json();
  }).then(function (json) {
    Curry._1(set, (function (param) {
      return decodePilotStatuses(json);
    }));
    return Promise.resolve();
  }).catch(function (param) {
    return Promise.resolve();
  });
}

const nullComp = {
  compName: "",
  scoreBack: undefined,
  utcOffset: {
    timeZoneMinutes: 0
  },
  from: "",
  dateTo: "",
  location: "",
  earth: {
    sphere: {
      radius: ""
    }
  },
  earthMath: "",
  give: {
    giveDistance: undefined,
    giveFraction: 0.0
  }
};

const nullNominals = {
  free: "",
  distance: "",
  time: "",
  goal: 0.0
};

export {
  nullComp,
  compSlug,
  nullNominals,
  nullPilotStatus,
  mkPilot,
  decodeError,
  asString,
  asFloat,
  asBool,
  asDict,
  asArray,
  field,
  optField,
  decodeUtcOffset,
  decodeRadius,
  decodeGive,
  decodeEarth,
  decodeComp,
  decodeNominals,
  decodeStopped,
  decodeRawZone,
  decodeRawZones,
  decodeTask,
  decodePilotStatuses,
  getComp,
  getNominals,
  getTaskLengths,
  getCompTasks,
  getCompPilots,
}
/* No side effect */
